/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { StyleSheet, css } from 'aphrodite';

import moment from 'moment-timezone'
import { ApiHelper } from '../helpers/ApiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { Helper } from '../helpers/Helper';
import { AppHelper } from '../../helpers/AppHelper';
import { BaseEntityPage } from './BaseEntityPage';
import { AppConfig } from '../../AppConfig';


function getExportFieldDef() {
  function getExportMonths() {
    const MAX_MONTHS = 12
    const result = [];
    for (let i = 0; i < MAX_MONTHS; i++) {
      const m = moment().subtract(i, 'months');
      result.push({
        label: m.format('MMMM, YYYY'),
        key: m.format('MMYYYY')
      });
    }
    return result;
  }
  const last3Months = getExportMonths()
  const fieldDef = {
    title: 'Export',
    ctaButtonText: 'Export',
    steps: [
      {
        fields: [
          {
            key: 'mmyyyy',
            type: 'radio',
            label: 'Month',
            tip: 'Choose the month in which staff activity occurred',
            options: last3Months,
            v_required: {
              value: true,
              err: 'Choose a month'
            },
            placement: 'left',
            defaultValue: last3Months[0].key,
          },
        ]
      }
    ]
  }
  return fieldDef
}

export class StaffActivity extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.pageTitle = Helper.getString('staff-activity')
    this.pageKey = 'staff-activity'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() }
    ]
    this.breadCrumbs.push({ title: this.pageTitle })
    this.toFetch = [
      { key: 'orgusers', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } },
      { key: 'suborgs', method: 'GET', paths: ['orgs'], queryParams: { parentOrgId: this.orgId } },
      { key: 'mainorg', method: 'GET', paths: ['orgs', this.orgId] },
    ]
    this.tableHeadersMap = {
      Index: (current) => { return current.__index + 1 },
      Name: (current) => { return Helper.formatName(current) },
      'Email/Phone': (current) => { return current.email || current.phone },
      Team: (current) => { return current.title || current.orgId },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.headerActions = [
      {
        label: 'Export',
        tooltip: 'Export',
        icon: 'download',
        type: 'icon-label',
        onClick: () => {
          const fieldDef = getExportFieldDef()
          fieldDef.title = Helper.getString('exportStaffActivity')
          this.openModalForAdd(fieldDef)
        }
      }
    ]
    this.emptyText = 'No staff in this org yet!'
    this.apiData = {}
  }

  openModalForAdd(fieldDef, apiData = {}) {
    this.apiData = {
      orgId: this.orgId,
      ...apiData,
    }

    let fieldDefinition = null
    if(fieldDef) {
      fieldDefinition = JSON.parse(JSON.stringify(fieldDef))
    }

    super.openModalForAdd(fieldDefinition)
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onFetchSuccess(results) {
    this.fieldDef = results[0].fieldDef
    this.formDefinition = this.fieldDef
    const orgUsers = this.getResult(results, 'orgusers').items
    const subOrgs = this.getResult(results, 'suborgs').items
    const mainOrg = this.getResult(results, 'mainorg')
    const orgInfo = subOrgs.reduce((p, c) => {
      p[c.orgId] = c
      return p
    }, {})
    orgInfo[mainOrg.orgId] = mainOrg
    let items =  orgUsers
    items.forEach(i => i.id = i.userId)
    items = items.filter((item)=> (item && Array.isArray(item.roles) && item.roles.includes('CRM')))
    items.sort((a, b) => a.orgId.localeCompare(b.orgId))
    items.forEach(i => {
      i.title = orgInfo[i.orgId] ? orgInfo[i.orgId].title : ''
    })
    this.setState({
      items: items,
    })
  }

  onActions(current) {
    const actions = []
    if (AppHelper.isStaffActivityTrackingEnabled(this.orgId)) {
      actions.push(<Link to={`/admin/orgs/${this.orgId}/staff-activity/${current.userId}`} key={current.userId}>
        <Tooltip title='View User' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>arrow_forward_ios</i>
          </span>
        </Tooltip>
      </Link>)
    }
    return actions
  }

  async customSubmitForExport(options) {
    const { formType, formData, caller } = options
    ApiHelper.callAwait({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'export-staff-activity'],
        queryParams: {orgId: this.orgId},
      }),
      jsonBody: formData,
    }).then(response => {
      window.open(this.baseRoute() + '/jobscrm', '_self')
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }


  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formData.mmyyyy) { return this.customSubmitForExport(options) }

    return caller.submit.call(caller, formData, true);
  }

}